import axios from "axios";
import ApiService from "./api";

import {buildUrl} from "@/common/helpers";
import {AD_CLIENT_ID, AD_NONCE, AD_TENANT_ID, APP_BASEURL, AZURE_API_URL} from "@/common/config";

const Auth = {
    me() {
        return ApiService.get('me');
    },
    getUserGroups() {
        return ApiService.get('me/memberOf');
    },
    getToken(code) {
        return axios.post(AZURE_API_URL+'get_token', {
            redirect_uri: APP_BASEURL,
            code: code
        });
    },
    redirectToAuthPage() {
        document.location.href = buildUrl(`https://login.microsoftonline.com/${AD_TENANT_ID}/oauth2/authorize`, {
            response_type: 'code',
            client_id: AD_CLIENT_ID,
            redirect_uri: encodeURIComponent(APP_BASEURL),
            nonce: AD_NONCE
        });
    },
};

export default Auth;